import React from 'react';
import { Selector } from './Selector/Selector';
import { useSettings } from '../providers/SettingsProvider';
import { useTexts } from '../useTexts';
export const QualitySelector = () => {
  const {
    menuQualityTitle
  } = useTexts();
  const {
    qualities,
    selectedQuality,
    setQualityLevel
  } = useSettings();
  const options = qualities.map(quality => ({
    displayText: quality.name,
    value: quality.level
  }));
  if (!selectedQuality) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Selector, {
    options: options,
    onSelect: setQualityLevel,
    selectedValue: selectedQuality.level,
    backButtonText: menuQualityTitle
  });
};
//# sourceMappingURL=QualitySelector.js.map